import { Component } from "@angular/core";
import { BaseTreeCellRenderer } from "src/app/shared/ag-gr/base-tree-cell-renderer";

@Component({
    selector: 'ag-tree-view',
    template: '',
    standalone: false
})

export class TreeCellRendererComponent extends BaseTreeCellRenderer {
    protected renderLoadingCell(params: any): void {
        this.eGui.innerHTML = (this.isLoading === true ? `${this.spinnerIcon()}` : '') +
            `${this.folderIcon("")}&nbsp;${this.formatValue(params.value)}`;
    }

    // Fixed: Check if api exists before calling autoSizeAllColumns
    // In ag-Grid v31+, use params.api instead of params.gridApi
    protected autoSizeColumns(params: any): void {
        if (params.api) {
            // Use setTimeout to ensure DOM is ready
            setTimeout(() => {
                params.api.autoSizeAllColumns();
            }, 0);
        }
    }

    public renderFolderFileCell(params: any) {
        if (params.data.expanded) {
            this.isLoading = false;
            if (params.data.isMaterializedDataset) {
                this.eGui.innerHTML = `${this.materializedFolderIcon("-open")}&nbsp;${this.formatValue(params.value)}`;
            } else {
                this.eGui.innerHTML = `${this.folderIcon("-open")}&nbsp;${this.formatValue(params.value)}`;
            }
        } else {
            this.eGui.innerHTML = (this.isLoading === true ? `${this.spinnerIcon()}` : '') +
                (params.data.isMaterializedDataset ? `${this.materializedFolderIcon("")}&nbsp;${this.formatValue(params.value)}` :
                    `${this.folderIcon("")}&nbsp;${this.formatValue(params.value)}`);
        }
    }

    public folderIcon(icon: string): string {
        return `<span class="fa-solid fa-folder${icon} fa-fw" style="color: #6acae9;"></span>`
    }

    public materializedFolderIcon(icon: string): string {
        return `<span class="fa-stack fa-fw" style="color: #6acae9; width: 1.28571em;">
                    <i class="fa-solid fa-folder${icon} fa-stack-1x"></i>
                    <i class="fa-solid fa-star fa-stack-1x fa-inverse" style="font-size: 5px; bottom:-3px; margin-left: 15%;"></i>
                </span>`
    }

    public spinnerIcon(): string {
        return `<i *ngIf="isLoading" class="fas fa-spinner fa-pulse mr-2 loading-animate"></i>`
    }
}